import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { isRTL } from "../../../utils";

export const MaintenanceNewApi = createApi({
  reducerPath: "MaintenanceNew",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND3_URL}/maintenance`,
    prepareHeaders: (headers, { getState }) => {
      headers.set("accept-language", isRTL ? "ar" : "en");
      const distanceUnit = getState().users?.user?.attributes?.distanceUnit;
      if (distanceUnit) headers.set("distance-unit", distanceUnit);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllRegularMaintenance: builder.query({
      query: ({
        page = 1,
        limit = 10,
        sortBy,
        sortOrder,
        search,
        trash,
      } = {}) => {
        const params = new URLSearchParams();
        params.set("page", page);
        params.set("limit", limit);
        if (sortBy) params.set("sortBy", sortBy);
        if (sortOrder) params.set("sortOrder", sortOrder);
        if (search) params.set("search", search);
        if (trash) params.set("trash", "true");
        return `?${params.toString()}`;
      },
    }),
    getRegularMaintenanceByTraccarId: builder.query({
      query: (id) => `/${id}`,
    }),
    createRegularMaintenance: builder.mutation({
      query: ({ body }) => {
        return {
          url: "",
          method: "POST",
          body: body,
        };
      },
    }),
    deleteRegularMaintenance: builder.mutation({
      query: (id) => {
        return {
          url: `/${id}`,
          method: "DELETE",
        };
      },
    }),
    editRegularMaintenance: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/${id}`,
          method: "PUT",
          body: body,
        };
      },
    }),
    getMaintenanceByVehicle: builder.query({
      query: (vehicleId) => `?deviceId=${vehicleId}`,
    }),
  }),
});

export const {
  useGetAllRegularMaintenanceQuery,
  useGetRegularMaintenanceByTraccarIdQuery,
  useCreateRegularMaintenanceMutation,
  useDeleteRegularMaintenanceMutation,
  useEditRegularMaintenanceMutation,
  useGetMaintenanceByVehicleQuery,
} = MaintenanceNewApi;
